export default __webpack_public_path__ + "assets/icon-email-component.dc754da4.svg";